<template>
  <teleport to="body">
    <div v-if="show" class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
      <div class="relative">
        <!-- Spinner -->
        <div v-if="isLoading" class="absolute inset-0 flex items-center justify-center">
          <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white"></div>
        </div>

        <!-- Image -->
        <img
            :src="url"
            @load="isLoading = false"
            @error="isLoading = false"
            alt="Image"
            class="max-h-[90vh] max-w-[90vw] rounded-xl shadow-xl"
            :class="{ 'opacity-0': isLoading }"
        />

        <!-- Close Button -->
        <button @click="$emit('close')" class="absolute top-2 right-2 text-white text-2xl font-bold">✕</button>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: "ImageViewer",
  emits: ['close'],
  props: {
    url: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
    };
  },
  watch: {
    url() {
      this.isLoading = true;
    },
    show(val) {
      if (val) this.isLoading = true;
    },
  },
};
</script>
